import Vue from 'vue';
import { Puzzle } from 'js/crossword/Puzzle';
import { Provider } from "js/crossword/types";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

import commonStyles from "../css/common.module.css";

declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    puzzle: Puzzle,
    withTimer: Boolean,
  },
  methods: {
    watchAd() {
      sdkHandler.trigger('interstitialAd', {
        callback: () => { 
          this.puzzle.clearPuzzle(this.withTimer);
          this.$emit('close');
        }}, this);
      
    },
  },
  render() {
    return (
      <PopupContainer customClasses={['clearPuzzlePopup']}>
        <div class='clearPuzzlePopup__message'>
          <div class={commonStyles.lineBreakEnabled}>
            {this.localization.get("Are you sure you want\nto clear the")} <b>
              {this.localization.get(this.withTimer ? "puzzle and timer?" : "puzzle?")}
            </b>
          </div>
          <div style='height: 1em'></div>
          <div>{this.localization.get("Watch an ad and clear it.")}</div>
        </div>

        <PopupButtons buttons={[{
          label: this.localization.get("Back"),
          onClick: () => sdkHandler.trigger('interstitialAd', { callback: function() {
            this.$emit("close");
          }}, this),
          reversed: true,
        }, {
          label: this.localization.get("Yes"),
          onClick: this.watchAd,
        }]} />
      </PopupContainer>
    );
  },
});
